import React from 'react';
import { ProjectStatuses } from '../../utilities/kanbanHelpers';
import { useAppSelector } from '../../store/hooks';
import { useGetMapInitDataQuery } from '../../store/slices/apiSlice/map-api-slice';
import Loader from '../loader/loader';
import { selectProjectStatuses } from '../../store/slices/mapSlice';
import Kanban from '../kanban';
import KanbanProjectCard from '../kanbanProjectCard';

const HomeLifecycleStatuses = [
    ProjectStatuses.PERMIT_ISSUED,
    ProjectStatuses.HORIZONTAL_CONSTRUCTION,
    ProjectStatuses.VERTICAL_CONSTRUCTION,
    ProjectStatuses.ON_MARKET,
    ProjectStatuses.SALE_ACCEPTED,
];

function HomeLifecycleKanban() {
    const { isLoading: mapInitIsLoading, error: initError } =
    useGetMapInitDataQuery();
    const projectStatusesDict = useAppSelector(selectProjectStatuses);

    const renderProjectCard = (item, index /*, handleNoteFeasible */) => {
        return <KanbanProjectCard key={item.aro_id} item={item} index={index} />;
    };

    if (mapInitIsLoading) {
        return <Loader />;
    }

    if (initError) {
        console.log('Error retrieving map init data', initError);
        return <p>Error retrieving map init data</p>;
    }

    return (
        <Kanban
            title="Home Lifecycle"
            kanbanStatuses={{
                statusNames: HomeLifecycleStatuses,
                dictionary: projectStatusesDict,
            }}
            project={true}
            kanbanItemRenderer={renderProjectCard}
        />
    );
}

export default HomeLifecycleKanban;
